module.exports = __webpack_public_path__ + "assets/img/Ober_005.54fe3797.jpg";